import styled from 'styled-components';

const Spacer = styled.div`
    width: 100%;
    margin: 5% 0 5% 0;
`;

export {
	Spacer
};
